import { createReducer, on } from '@ngrx/store';
import { initialLoginCredentialsState, LoginCredentialsState } from './state';
import {
  clearLoginCredentials,
  requestSuccess,
  requestError,
  loginCredentials,
} from './actions';

export const loginCredentialsReducer = createReducer(
  initialLoginCredentialsState,
  on(loginCredentials, (state): LoginCredentialsState => {
    return { ...state, loading: true };
  }),
  on(requestSuccess, (state, { response }): LoginCredentialsState => {
    return {
      error: false,
      loading: false,
      response: response,
    };
  }),
  on(requestError, (state, { error }): LoginCredentialsState => {
    return {
      error: error,
      loading: false,
      response: null,
    };
  }),
  on(clearLoginCredentials, (state): LoginCredentialsState => {
    return {
      error: false,
      loading: false,
      response: null,
    };
  })
);
